import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPickings from '../reducers/pickings.reducer';

export const selectPickingsState = createFeatureSelector<fromPickings.State>(
  fromPickings.pickingsFeatureKey
);

export const selectPickingState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.picking
);

export const selectPickingsPathState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.pickingsPath
);

export const selectPickingsFilterTypeState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.filterType
);

export const selectPickingsIsLoadingState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.isLoading
);

export const selectPickingsIsMaster = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.isMasterChecked
);


export const selectPickingListState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.pickings
);

export const selectPickingsFilterIDState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.filterID
);

export const selectPickingsQueryState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.query
);

export const selectPickingsSelectedState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.selected
);

export const selectPickingsBarcodeState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.barcodes
);

export const selectPickingsDuplicateBarcodeState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.duplicateBarcode
);

export const selectPickingsSortState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.sortType
);

export const selectPickingsDirectionState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => state.direction
);

export const selectPickingPageState = createSelector(
  selectPickingsState,
  (state: fromPickings.State) => {
    state.direction
  }
);
